import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import UserMessageModal from '@techsee/techsee-ui-common/lib/modals/user-message-modal';
import {INotificationController} from './controller';

import './styles.scss';

export interface NotificationModalProps {
    ctrl: INotificationController;
}

@observer
export class NotificationModal extends TechseeBaseComponent<NotificationModalProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        const Content = () => <span className={ctrl.isError ? 'errorMsg' : ''}>{ctrl.content}</span>;

        return (
            <UserMessageModal
                className='notification-modal'
                content={Content}
                onOkButtonClick={() => ctrl.hide()}
                show={ctrl.isVisible}
                okButtonText='OK'
            />
        );
    }
}
